<div class="container-fluid">
  <div class="row">
    <div class="col-lg-12 mb-2">
      <div class="card">
        <div class="card-header bg-blue-grey-400" style="cursor: pointer">
          Calculate RdSAP results from input data
        </div>
        <div class="card-body d-flex justify-content-between">
          <div>
            <button *ngIf="showCalculateButton" style="cursor: pointer" class="btn btn-info" [disabled]="isLoading" (click)="calculate()">
              <i class="bi bi-icon bi-calculator"></i> Calculate
            </button>
            <button *ngIf="showEpcPreviewButton" style="cursor: pointer" class="btn btn-info ml-2" (click)="preview()">
              {{ getButtonText() }}
            </button>
            <button *ngIf="showLodgeButton" style="cursor: pointer" class="btn btn-info ml-2" (click)="lodge()">
              Lodge
            </button>
            <button *ngIf="showOpenEPCButton" style="cursor: pointer" class="btn btn-info ml-2" (click)="getEPC()">
              Open EPC
            </button>
            <ng-template #calculateTip *ngIf="isEdit">Calculate disabled in edit mode</ng-template>
          </div>
          <div>
          <button *ngIf="showSapWorksheetButton" style="cursor: pointer" class="btn btn-info" (click)="downloadPdf()">
            SAP Worksheet
          </button>
          </div>
        </div>
      </div>
    </div>
    <app-rdsap-ratings [result]="eeStatusDetails"></app-rdsap-ratings>

    <app-rdsap-recommendations
    [eeRecommendations]="eeRecommendations"
    (deselectedItemsData)="setDeselectedItems(eeGeneralDetails, $event.deselectedImprovementMeasures)">
  </app-rdsap-recommendations>
  <div class="col-lg-6">
    <app-rdsap-summary-addenda (addendaData)="setAddendum(eeGeneralDetails, $event.addendum)" [getAddendum]="getAddendum"></app-rdsap-summary-addenda>
  </div>
  <div class="col-lg-6">
    <app-rdsap-summary-details [eeStatusDetails]="eeStatusDetails"></app-rdsap-summary-details>
      </div>


</div>
</div>
<ng-template #standardTpl> {{ standardMessage }} </ng-template>

<ng-template #successTpl> {{ successMessage }} </ng-template>

<ng-template #dangerTpl>
  <svg xmlns="http://www.w3.org/2000/svg" fill="#fff" width="24" height="24" viewBox="0 0 24 24">
    <path
      d="M10.872 6.831l1.695 3.904 3.654-1.561-1.79 3.426 3.333.954-3.417 1.338 2.231 4.196-4.773-2.582-2.869 2.287.413-3.004-3.792-.726 2.93-1.74-1.885-2.512 3.427.646.843-4.626zm-.786-6.831l-1.665 9.119-6.512-1.228 3.639 4.851-5.548 3.294 7.108 1.361-.834 6.076 5.742-4.577 9.438 5.104-4.288-8.064 6.834-2.677-6.661-1.907 3.25-6.22-6.98 2.982-3.523-8.114z"
    />
  </svg>
  {{ errorMessage }}
</ng-template>
<app-toasts aria-live="polite" aria-atomic="true"></app-toasts>
